import { createWebHistory, createRouter } from 'vue-router'
import Login from '@/views/LoginPage.vue'
import Index from '@/views/IndexPage.vue'
import Home from '@/views/HomePage.vue'
import Amend from '@/views/AmendPage.vue'
import NotFound from '@/views/NotFound.vue'
import { guardPage } from '@/plugins/auth'
import middlewarePipeline from '@/middleware/middlewarePipeline'




const isLoginPageEnabled = process.env.VUE_APP_IS_LOGIN_ENABLED;
const routes = [{
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            //pageTitle: 'Login'
            // requiresAuth: false
        }
    },

    {
        path: '/',
        component: Index,
        children: [{
                // Home will be rendered inside Index's <router-view>
                // when / is matched
                path: '',
                component: Home,
                meta: {
                    //requiresAuth: true
                    // pageTitle: 'Consent',
                    middleware: [guardPage]
                }
            },
            {
                path: 'amend',
                component: Amend,
                meta: {
                    pageTitle: 'Consent',
                    middleware: [guardPage]
                        //requiresAuth: true
                }
            }
        ]
    },
    { path: '/:catchAll(.*)', component: NotFound }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    // base: process.env.BASE_URL,
    routes
})


if (isLoginPageEnabled === "true") {
    router.beforeEach((to, from, next) => {
        if (!to.meta.middleware) {
            return next()
        }
        const middleware = to.meta.middleware

        const context = {
            to,
            // from,
            next,
            // store
        }
        return middleware[0]({
            ...context,
            next: middlewarePipeline(context, middleware, 1)
        })
    })
}

export default router